// extracted by mini-css-extract-plugin
module.exports = {"containerPost":"post_containerPost__gKylX","articleContainer":"post_articleContainer__OEIP_","articleRow":"post_articleRow__FbubN"};